/* Prime Select USA — Shopify connectivity bridge.
   Connects the demo storefront UI to Shopify's native Cart & Checkout.
   Safe to load on every page; all hooks are optional and guarded. */
(function () {
  "use strict";
  var R = (window.PRIME_SHOPIFY && window.PRIME_SHOPIFY.routes) || {};
  var addUrl = (R.cart_add_url || "/cart/add") + ".js";
  var cartUrl = (R.cart_url || "/cart");
  var checkoutUrl = "/checkout";

  function toast(msg) {
    var t = document.getElementById("toast");
    if (!t) { return; }
    t.textContent = msg; t.classList.add("is-visible");
    setTimeout(function () { t.classList.remove("is-visible"); }, 2600);
  }

  // Add a real Shopify variant to the Shopify cart.
  window.PrimeShopify = {
    addVariant: function (variantId, qty) {
      if (!variantId) { return Promise.reject("no variant id"); }
      return fetch(addUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: qty || 1 })
      }).then(function (r) { return r.json(); })
        .then(function (data) { toast("Added to cart"); document.dispatchEvent(new CustomEvent("prime:cart:added", { detail: data })); return data; })
        .catch(function (e) { toast("Could not add to cart"); throw e; });
    },
    goToCart: function () { window.location.href = cartUrl; },
    checkout: function () { window.location.href = checkoutUrl; }
  };

  document.addEventListener("DOMContentLoaded", function () {
    // Any element marked with a real Shopify variant id adds to the live cart.
    document.body.addEventListener("click", function (e) {
      var el = e.target.closest("[data-shopify-variant-id]");
      if (!el) { return; }
      e.preventDefault();
      window.PrimeShopify.addVariant(el.getAttribute("data-shopify-variant-id"), parseInt(el.getAttribute("data-qty") || "1", 10));
    });


    // Route account controls to native Shopify customer pages (capture-phase wins over demo handlers).
    var loginUrl = R.account_login_url || "/account/login";
    var accountUrl = R.account_url || "/account";
    var signIn = document.getElementById("signInBtn");
    if (signIn) { signIn.addEventListener("click", function (e) { e.stopImmediatePropagation(); window.location.href = loginUrl; }, true); }
    var myAccount = document.getElementById("myAccountBtn");
    if (myAccount) { myAccount.addEventListener("click", function (e) { e.stopImmediatePropagation(); window.location.href = window.PRIME_SHOPIFY && window.PRIME_SHOPIFY.customer ? accountUrl : loginUrl; }, true); }

    // Native search on submit (Enter) while keeping the predictive panel on typing.
    var searchForm = document.querySelector(".search-form");
    if (searchForm) {
      searchForm.addEventListener("submit", function (e) {
        var input = searchForm.querySelector('input[name="q"]') || document.getElementById("searchInput");
        var q = (input && input.value || "").trim();
        if (q) { e.stopImmediatePropagation(); e.preventDefault(); window.location.href = (R.search_url || "/search") + "?q=" + encodeURIComponent(q); }
      }, true);
    }

    // Demo checkout button: if the real Shopify cart has items, send to Shopify checkout.
    var checkoutBtn = document.getElementById("checkoutBtn");
    if (checkoutBtn) {
      checkoutBtn.addEventListener("click", function () {
        fetch(cartUrl + ".js", { headers: { "Accept": "application/json" } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (cart && cart.item_count > 0) { window.PrimeShopify.checkout(); }
          }).catch(function () { /* keep demo behaviour */ });
      }, true);
    }
  });
})();
